import React from "react";
import { connect } from "react-redux";
import {
    Layout,
    Button,
    Row,
    Col,
    Card,
    Input,
    Select,
    Space,
    Spin,
    Alert,
    Collapse,
    Modal,
    Table,
    InputNumber,
    Radio,
    Switch,
    Typography,
    Tooltip,

} from "antd";
import {
    SaveOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    WarningOutlined,
    CloseCircleOutlined,
} from "@ant-design/icons";
import {
    Header,
    InputCurrency,
    SwitchLabel,
    InputMask,
    CreditCard,
    FormAddress,
    AutoCompleteCompany,
    Form,
    FormatDate,
} from "components";
import { useNavigate, useParams } from "react-router-dom";
import {
    ANNUAL_REVENUE_RANGE_DATA,
    MARITAL_STATUS_DATA,
    MONTHLY_REVENUE_RANGE_DATA,
    REPRESENTATIVE_LEGAL_DATA,
    SEX_DATA,
    USER_TYPE,
    USER_TYPE_DATA,
    isOperatorType,
    kycStatus as KYC_STATUS,
    biometricStatus as BIOMETRIC_STATUS,
} from "utils/static-data";
import {
    getAllOccupationV2,
    saveUser,
    saveUserBatch,
    getUserKycStatus,
    disableUser,
} from "services/user-service";
import {
    getByIdCard,
    loadHistoryCards,
    blockCard as block,
    issueCorporateVirtualCard,
    blockCorporateCard,
    removeCorporateAccount,
    retrieveCorporateCardEmployee,
} from "services/card-service";
import { bindActionCreators } from "redux";
import * as balanceAction from "actions/balance-action";
import moment from "moment";
import { translate } from "config/language";
import { getFieldUser } from "utils";
import { DatePicker } from "components";

const { Footer, Content } = Layout;
const PJ = "PJ";
const PF = "PF";

const STATUS_STYLE = {
    success: { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', Icon: CheckCircleOutlined },
    info: { color: '#1677ff', bg: '#e6f4ff', border: '#91caff', Icon: InfoCircleOutlined },
    warning: { color: '#faad14', bg: '#fffbe6', border: '#ffe58f', Icon: WarningOutlined },
    error: { color: '#ff4d4f', bg: '#fff2f0', border: '#ffccc7', Icon: CloseCircleOutlined },
};

const statusCollapseItem = ({ key, type, label, details }) => {
    const s = STATUS_STYLE[type] || STATUS_STYLE.info;
    const { Icon } = s;
    return {
        key,
        label: (
            <span style={{ color: s.color, fontWeight: 500 }}>
                <Icon style={{ marginRight: 6 }} />
                {label}
            </span>
        ),
        style: {
            background: s.bg,
            border: `1px solid ${s.border}`,
            borderRadius: 6,
            marginBottom: 0,
        },
        children: details.length > 0
            ? <ul style={{ margin: 0, paddingLeft: 20 }}>
                {details.map((d, i) => <li key={i}>{d}</li>)}
            </ul>
            : <span style={{ color: '#8c8c8c' }}>Sem detalhes registrados</span>,
    };
};

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer,
    balance: state.balanceReducer,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...balanceAction,
        },
        dispatch
    );

const MASTER_USER_TYPES = [USER_TYPE.OPERATOR, USER_TYPE.COMPANY_OPERATOR];

const UserDetailsScreen = React.forwardRef((props, ref) => {
    const {
        login,
        compact = false,
        user = null,
        balance,
        onSubmit = () => { },
    } = props;
    const { id = user } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [subRoutes, setSubRoutes] = React.useState([]);
    const [data, setData] = React.useState(null);
    const [cards, setCards] = React.useState([]);
    const [alerts, setAlerts] = React.useState([]);
    const [occupations, setOccupations] = React.useState([]);
    const [cardActive, setCardActive] = React.useState([]);
    const [openSocialName, setOpenSocialName] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [loadingCards, setLoadingCards] = React.useState(false);
    const [cardHistoryShow, setCardHistoryShow] = React.useState(false);
    const [motherRequired, setMotherRequired] = React.useState(false);
    const wtCompany = Form.useWatch("companyExternal", form);
    const wtUserType = Form.useWatch(["userType", "code"], form);
    const wtCompanyId = Form.useWatch(["company", "id"], form);
    const CARD_TYPE_PHYSICAL = 'physical';
    const CARD_TYPE_VIRTUAL = 'virtual';
    const [historyModalText, setHistoryModalText] = React.useState('');
    const birthday = Form.useWatch("birthday", form);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = React.useState(false);
    const [isConfirmLoading, setIsConfirmLoading] = React.useState(false);
    const [legalEntity, setLegalEntity] = React.useState(PF);
    const [showLegalEntityModal, setShowLegalEntityModal] = React.useState(false);
    const [canEditFields, setCanEditFields] = React.useState(true);
    const [canEditCPF, setCanEditCPF] = React.useState(true);
    const [canEditLegalCPF, setCanEditLegalCPF] = React.useState(true);
    const legalRepTypeRef = React.useRef(null);
    const [corporateCard, setCorporateCard] = React.useState(null);
    const [loadingCorporateCard, setLoadingCorporateCard] = React.useState(true);
    const [issueCardModal, setIssueCardModal] = React.useState(false);
    const [corporatePin, setCorporatePin] = React.useState('');
    const [corporatePinConfirm, setCorporatePinConfirm] = React.useState('');
    const [issuingCorporateCard, setIssuingCorporateCard] = React.useState(false);
    const [removingCorporateAccount, setRemovingCorporateAccount] = React.useState(false);

    const loadSubRoutes = () => {
        if (id) {
            let routes = [
                { label: `Senha${' \\ Biometria'}`, route: `/user/${id}/forgot` }
            ];
            if (login.company.master || login.user.admin) {
                routes = [
                    {
                        label: `Resgatar Saldo`,
                        button: true,
                        redeem: true,
                    },
                    { label: `Senha${' \\ Biometria'}`, route: `/user/${id}/forgot` },
                    // { label: `Gerência`, route: `/user/${id}/manager` },
                ]
            }

            // if(login.user.feature.advantage) {
            //     routes.push({ label: "Vantagens", route: `/user/${id}/advantages` });
            // }

            if (!isOperator() && (login.company.master || login.user.admin)) {
                routes.push({ label: "Mudar de Empresa", route: `/user/${id}/company` });
            }

            routes.push({
                label: `Consultar Extrato`,
                route: `/user/${id}/statement`,
            });

            if (login.company.master) {
                routes.push({ label: "Cargas", route: `/user/${id}/solicitations` });
                routes.push({
                    label: "Histórico de Empresas",
                    route: `/user/${id}/history`,
                });
            }
            setSubRoutes(routes);
        }
    };

    const isOperator = () => {
        return isOperatorType(login.user.userType);
    };

    const canManageCompanyOperator = () => {
        return login.user.admin && login.company.master;
    };

    const isUserTypeLocked = () => {
        if (!data) return false;
        const code = data.userType.code;
        return (isOperator() && (code === USER_TYPE.ADMIN || code === USER_TYPE.COMPANY_OPERATOR)) ||
            (!canManageCompanyOperator() && code === USER_TYPE.COMPANY_OPERATOR);
    };

    // Usuário da master: na edição vem do próprio usuário; no cadastro, Empresa vazia = empresa logada (master)
    const isMasterUser = id
        ? !!(data && data.companyExternal && data.companyExternal.master)
        : !compact && login.company.master && !wtCompanyId;

    const availableUserTypes = () => {
        if (isUserTypeLocked()) {
            return USER_TYPE_DATA.filter((x) => x.code === data.userType.code);
        }
        return USER_TYPE_DATA.filter((x) =>
            (x.code !== USER_TYPE.ADMIN || !isOperator()) &&
            (x.code !== USER_TYPE.COMPANY_OPERATOR || canManageCompanyOperator()) &&
            (!isMasterUser || MASTER_USER_TYPES.includes(x.code) || (data && x.code === data.userType.code))
        );
    };

    const isCreatingCompanyOperator = !id && wtUserType === USER_TYPE.COMPANY_OPERATOR;

    React.useEffect(() => {
        if (isCreatingCompanyOperator) {
            form.setFieldsValue({ company: { id: null }, companyExternal: null });
        }
    }, [isCreatingCompanyOperator, form]);

    React.useEffect(() => {
        if (!id && isMasterUser && wtUserType && !MASTER_USER_TYPES.includes(wtUserType)) {
            form.setFieldsValue({ userType: { code: USER_TYPE.OPERATOR } });
        }
    }, [id, isMasterUser, wtUserType, form]);

    const load = async () => {
        setLoading(true);
        setOccupations(await getAllOccupationV2());
        if (id) {
            const res = await getUserKycStatus(id);

            if (res) {
                if (!res.newCompany) {
                    const resCard = await getByIdCard(id);
                    setCardActive(resCard);
                } else if (res.card) {
                    setCardActive([{ cardId: res.cardId }]);
                }

                setLoadingCorporateCard(true);
                const corpEntry = await retrieveCorporateCardEmployee(id);
                setCorporateCard(corpEntry || null);
                setLoadingCorporateCard(false);
                setLegalEntity(res.cnpj || res.disabledCnpj ? PJ : PF);
                setData(res);
                setCanEditCPF(res.cpf === null && !res.disabledCpf && !res.disabledCnpj);
                var approvedBiometric = res.biometricStatus === 'APPROVED' || res.biometricStatus === 'A';
                if (res.validation.code === 'S' || (res.kycStatus === 'A' && approvedBiometric)) {
                    setCanEditFields(false);
                }
            }
        } else {
            form.setFieldsValue({
                company: login.company.master ? {} : login.company,
                companyExternal: login.company.master ? {} : login.company,
            });
        }
        setLoading(false);
    };

    const formatPhoneNumber = (phoneNumber) => {
        const cleaned = phoneNumber.startsWith('55') ? phoneNumber.slice(2) : phoneNumber;
        const onlyNumbers = cleaned.replace(/\D/g, '');
        const match = onlyNumbers.match(/^(\d{2})(\d{5})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phoneNumber;
    };

    const loadFields = () => {
        if (data.birthday) {
            setMotherRequired(moment().diff(data.birthday, "years") < 18);
        }

        const formattedPhone = data.phone
            ? formatPhoneNumber(data.phone.startsWith("55") ? data.phone.substring(2) : data.phone)
            : null;

        let legalRepresentative = data.legalRepresentative
        ? {
            ...data.legalRepresentative,
            birthday: data.legalRepresentative.birthday
                ? moment(data.legalRepresentative.birthday)
                : null,
            phoneNumber: data.legalRepresentative.phoneNumber
                ? formatPhoneNumber(data.legalRepresentative.phoneNumber)
                : null,
            relationshipType: data.legalRepresentative.relationshipType
                ? data.legalRepresentative.relationshipType.toLowerCase()
                : null,
          }
        : null;
        legalRepTypeRef.current = legalRepresentative?.relationshipType ?? null;
        if(legalRepresentative && legalRepresentative.kycStatus == 'A' && legalRepresentative.biometricStatus != null && legalRepresentative.biometricStatus.toLowerCase() == 'approved') {
            setCanEditLegalCPF(false);
        }


        form.setFieldsValue({
            ...data,
            companyExternal: data.companyExternal,
            phone: formattedPhone,
            birthday: data.birthday ? moment(data.birthday) : null,
            occupation: data.occupation ? Number(data.occupation) : null,
            legalRepresentative
        });
        setOpenSocialName(data.hasSocialName);
    };

    const cleanseCPF = (cpf) => {
        return cpf.replace(/[^0-9]/g, '');
    }

    const cleanseCNPJ = (cnpj) => {
        return cnpj.replace(/[^0-9]/g, '');
    }

    const onDisable = async () => {
        setLoading(true);
        setIsConfirmLoading(true);
        var disabled = !data.backofficeDisable;
        var res = await disableUser(id, disabled);
        if (res.success) {
            navigate("/user");
        }
        setLoading(false);
        setIsConfirmLoading(false);
        setIsConfirmModalVisible(false);
    }

    const onSave = async (values) => {
        setLoading(true);
        try {
            values.cpf = cleanseCPF(values.cpf);
            if (values.cnpj) {
                values.cnpj = cleanseCNPJ(values.cnpj);
            }
            values.userIssueCardLimit = values.userIssueCardLimit || 0;
            if (!compact) {
                const occupationName = values.occupation
                    ? occupations.find((x) => x.id === values.occupation).name
                    : null;
                try {
                    if (values.legalRepresentative?.relationshipType === "emancipated_minor") {
                        values.legalRepresentative.name = values.name;
                        values.legalRepresentative.phoneNumber = values.phone;
                        values.legalRepresentative.email = values.email;
                        values.legalRepresentative.document = values.cpf;
                        values.legalRepresentative.birthday = values.birthday;
                        values.legalRepresentative.monthlyRevenueRange = values.monthlyRevenueRange;
                        const { zipcode, country, address, number, complement, neighborhood, city, state } = values.address || {};
                        values.legalRepresentative.address = { zipcode, country, address, number, complement, neighborhood, city, state };
                    } else if (values.legalRepresentative?.sameAddress === true) {
                        values.legalRepresentative.address = values.address
                            ? { ...values.address }
                            : {};
                        if (values.legalRepresentative.document != null) {
                            values.legalRepresentative.document = cleanseCPF(values.legalRepresentative.document);
                        }
                    } else if (values.legalRepresentative != null && values.legalRepresentative.document != null) {
                        values.legalRepresentative.document = cleanseCPF(values.legalRepresentative.document);
                    }
                    await saveUser(id, { ...values, occupationName: occupationName });
                    navigate("/user");
                } catch (err) {
                    if (err.data && err.data.infos && err.data.infos.field) {
                        let field = getFieldUser(err.data.infos.field);
                        form.setFields([
                            {
                                name: field,
                                errors: [err.data.errorMessage],
                            },
                        ]);
                    }
                }
            } else {
                const body = {
                    ...values,
                    enabled: true,
                    id: id ? id : 0,
                    sex: values.userSex.code,
                };
                delete body.userSex;
                delete body.companyExternal;
                await saveUserBatch(body);
                form.resetFields();
                onSubmit();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const createAccountStatus = () => {
        if (data) {
            const accountStatus = data.accountSwapStatus;
            if (accountStatus) {
                const status = accountStatus.toLowerCase();
                let category = "info";
                if (status === "success") {
                    category = "success";
                } else if (status === "error") {
                    category = "error";
                }
                return (
                    <Alert
                        message={`Status de Conta: ${status === "success" ? "Ativo" : "Inativo"
                            }`}
                        type={category}
                        showIcon
                    />
                );
            }
        }
        return null;
    };

    const createCardStatus = (card) => {
        if (data) {
            if (data.newCompany) {
                return (
                    <Alert
                        message={`Status: Mudança de Empresa`}
                        type={"warning"}
                        showIcon
                    />
                );
            }
            const cardStatus = card && card.status ? card.status : data.cardStatus;
            if (cardStatus) {
                const status = cardStatus.toLowerCase();
                let category = "info";
                if (status === "inativo") {
                    category = "warning";
                } else if (status === "ativo" || status === "enviando") {
                    category = "success";
                } else if (status === "bloqueado") {
                    category = "error";
                }
                return (
                    <Alert
                        message={`Status: ${cardStatus.toUpperCase()}`}
                        type={category}
                        showIcon
                    />
                );
            }
        }
        return null;
    };

    const PIN_RULES = [
        {
            key: 'repeatedDigits',
            rule: 'Dígitos iguais',
            description: 'O PIN não pode ter mais de 50% dos dígitos iguais.',
            examples: '1111, 2022, 3335',
        },
        {
            key: 'ascending',
            rule: 'Sequência crescente',
            description: 'O PIN não pode seguir uma sequência lógica incremental.',
            examples: '1234, 5678',
        },
        {
            key: 'descending',
            rule: 'Sequência decrescente',
            description: 'O PIN não pode seguir uma sequência lógica decremental.',
            examples: '9876, 5432',
        },
    ];

    const getPinValidation = (pin) => {
        if (!pin || pin.length < 4) return {};
        const digits = pin.split('').map(Number);
        const counts = {};
        for (const d of digits) counts[d] = (counts[d] || 0) + 1;
        return {
            repeatedDigits: !Object.values(counts).some(c => c > digits.length / 2),
            ascending: !digits.every((d, i) => i === 0 || d - digits[i - 1] === 1),
            descending: !digits.every((d, i) => i === 0 || digits[i - 1] - d === 1),
        };
    };

    const handleBlockCorporateCard = () => {
        Modal.confirm({
            title: 'Bloquear cartão corporativo?',
            content: 'O portador não poderá utilizar o cartão. Para reativar o acesso, será necessário emitir um novo cartão.',
            okText: 'Bloquear',
            okButtonProps: { danger: true },
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    setLoadingCorporateCard(true);
                    await blockCorporateCard(id, 'blocked');
                    const entry = await retrieveCorporateCardEmployee(id);
                    setCorporateCard(entry || null);
                } finally {
                    setLoadingCorporateCard(false);
                }
            },
        });
    };

    const handleRemoveCorporateAccount = async () => {
        try {
            setRemovingCorporateAccount(true);
            await removeCorporateAccount(id);
            setCorporateCard(null);
            Modal.success({ title: 'Conta corporativa removida com sucesso.' });
            load();
        } finally {
            setRemovingCorporateAccount(false);
        }
    };

    const handleRemoveCorporateAccountConfirm = () => {
        Modal.confirm({
            centered: true,
            title: 'Remover conta corporativa?',
            content: 'O cartão do participante será bloqueado e cancelado, o saldo disponível será devolvido automaticamente para a empresa e a conta será encerrada. Esta ação não pode ser desfeita — para reativar o acesso será necessário emitir um novo cartão.',
            okText: 'Remover',
            okButtonProps: { danger: true },
            cancelText: 'Cancelar',
            onOk: handleRemoveCorporateAccount,
        });
    };

    const handleIssueCorporateCard = async () => {
        if (corporatePin.length !== 4 || !/^\d{4}$/.test(corporatePin)) {
            Modal.warning({ title: 'PIN inválido', content: 'Informe exatamente 4 dígitos numéricos.' });
            return;
        }
        if (corporatePin !== corporatePinConfirm) {
            Modal.warning({ title: 'PINs diferentes', content: 'Os PINs informados não coincidem.' });
            return;
        }
        const pinValidation = getPinValidation(corporatePin);
        if (Object.values(pinValidation).some(v => v === false)) {
            Modal.warning({ title: 'PIN inválido', content: 'O PIN não atende às regras de segurança.' });
            return;
        }
        setIssuingCorporateCard(true);
        try {
            const result = await issueCorporateVirtualCard(id, { pin: corporatePin, singleUse: false });
            if (result) {
                Modal.success({ title: 'Cartão corporativo emitido com sucesso!' });
                setIssueCardModal(false);
                setCorporatePin('');
                setCorporatePinConfirm('');
                setLoadingCorporateCard(true);
                const entry = await retrieveCorporateCardEmployee(id);
                setCorporateCard(entry || null);
                setLoadingCorporateCard(false);
            }
        } finally {
            setIssuingCorporateCard(false);
        }
    };

    const blockCard = async (card, status) => {
        setLoading(true);
        try {
            await block(id, card, status);
            setCardActive(await getByIdCard(id));
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const openHistoryCards = async (cardType) => {

        const modalText = cardType === CARD_TYPE_VIRTUAL ? 'Cartões Virtuais do Participante' : 'Cartões Físicos do Participante';
        setHistoryModalText(modalText);

        setCards([]);
        setLoadingCards(true);
        setCardHistoryShow(true);
        try {
            let res = await loadHistoryCards(id, cardType);
            setCards(res);
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingCards(false);
        }
    };

    const formatStatusDate = (dateObj) => {
        if (!dateObj) return null;
        const { dayOfMonth, monthValue, year, hour, minute } = dateObj;
        const utcDate = new Date(Date.UTC(year, monthValue - 1, dayOfMonth, hour, minute));
        utcDate.setUTCHours(utcDate.getUTCHours() - 3);
        const dd = String(utcDate.getUTCDate()).padStart(2, '0');
        const mm = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
        const yyyy = utcDate.getUTCFullYear();
        const HH = String(utcDate.getUTCHours()).padStart(2, '0');
        const min = String(utcDate.getUTCMinutes()).padStart(2, '0');

        return `${HH}:${min} ${dd}/${mm}/${yyyy}`;
    };

    const createKycStatus = (source = data) => {
        if (!source) return null;

        const items = [];

        if (source.kycStatus && KYC_STATUS[source.kycStatus]) {
            const kyc = KYC_STATUS[source.kycStatus];
            const type = kyc.type === 'finish' ? 'success' : kyc.type === 'error' ? 'error' : 'info';
            const date = formatStatusDate(source.kycUpdatedStatusAt);
            items.push({
                key: 'kyc',
                type,
                label: `Validação de Dados: ${kyc.text}${date ? ` — ${date}` : ''}`,
                details: (source.kycErrors || []).filter(Boolean),
            });
        } else if (source.validation) {
            const type = source.validation.category || 'info';
            const date = formatStatusDate(source.kycUpdatedStatusAt);
            items.push({
                key: 'validation',
                type,
                label: `Validação de Dados: ${source.validation.name}${date ? ` — ${date}` : ''}`,
                details: (source.kycErrors || []).filter(Boolean),
            });
        }

        if (source.biometricStatus && BIOMETRIC_STATUS[source.biometricStatus]) {
            const bio = BIOMETRIC_STATUS[source.biometricStatus];
            const type = bio.type === 'finish' ? 'success' : bio.type === 'error' ? 'error' : 'info';
            const details = [
                ...(source.biometricErrors || []),
                ...(source.biometricStatusReasons || []),
            ].filter(Boolean);
            const date = formatStatusDate(source.biometricUpdatedStatusAt);
            items.push({ key: 'biometric', type, label: `Biometria: ${bio.text}${date ? ` — ${date}` : ''}`, details });
        }

        if (items.length === 0) return null;

        return (
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={24} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {items.map(({ key, type, label, details }) =>
                        type === 'error' ? (
                            <Collapse
                                key={key}
                                items={[statusCollapseItem({ key, type, label, details })]}
                                style={{ background: 'transparent', border: 'none' }}
                            />
                        ) : (
                            <Alert key={key} type={type} message={label} showIcon />
                        )
                    )}
                </Col>
            </Row>
        );
    }

    const loadAlerts = () => {
        const newAlerts = [];

        if (data && data.newCompany && login.company.master) {
            newAlerts.push({
                message: "Esse usuário está associado a uma nova empresa. Altere a empresa para que ele possa utilizar o cartão.",
                type: "warning",
            })
        }

        if (data && (data.disabledCpf || data.disabledCnpj)) {
            const documents = [
                data.disabledCpf && `CPF ${data.disabledCpf}`,
                data.disabledCnpj && `CNPJ ${data.disabledCnpj}`,
            ].filter(Boolean).join(" / ");
            newAlerts.push({
                message: `Participante desativado. Documento liberado para novo cadastro: ${documents}. Ele volta ao habilitar o participante.`,
                type: "warning",
            });
        }

        if (data && data.accountSwapStatus === "ERROR") {
            newAlerts.push({
                message: "Participante com conta inativa devido à falta de primeiro acesso ou conta de cartão bloqueada.",
                type: "warning",
            });
        }

        setAlerts(newAlerts);

    };

    React.useImperativeHandle(ref, () => {
        return {
            submit() {
                form.submit();
            },
        };
    });

    const redirectPage = (url) => {
        if (balance.company.subBalances.length == 0) {
            navigate(url, { state: { benefit: null } });
        } else if (balance.company.subBalances.length == 1) {
            navigate(url, {
                state: { benefit: balance.company.subBalances[0].benefit },
            });
        } else {
            navigate("/solicitation/balance", {
                state: {
                    url: url,
                    type: "credit",
                    description: `Selecione um ${translate(
                        "balance"
                    )} de destino para o resgate`,
                },
            });
        }
    };

    React.useEffect(() => {
        if (data) {
            loadFields();
            loadAlerts();
        }
    }, [data]);

    React.useEffect(() => {
        loadSubRoutes();
        load();
    }, [id]);

    const under18 = React.useMemo(() => {
        if (!birthday) return false;
        return moment().diff(birthday, "years") < 18;
    }, [birthday]);

    return (
        <Layout className="alymente-layout">
            {!compact && (
                <Header
                    title={`${data && data.name ? data.name : ""}`}
                    routes={subRoutes}
                    onSelectRoute={(d) =>
                        d.redeem ? redirectPage(`/user/${id}/redeem`) : null
                    }
                />
            )}
            <Content style={compact ? { paddingRight: 8, paddingLeft: 8 } : {}}>
                {!compact && (
                    <Col gutter={16} style={{ marginBottom: 30 }}>
                        {alerts.map((a) => (
                            <Col
                                xl={compact ? 24 : 12}
                                lg={compact ? 24 : 18}
                                md={compact ? 24 : 24}
                                style={{ margin: '0 auto 15px' }}
                            >
                                <Alert showIcon message={a.message} type={a.type} />
                            </Col>
                        ))}
                    </Col>
                )}

                <Row justify="center">
                    <Col
                        xl={compact ? 24 : 12}
                        lg={compact ? 24 : 18}
                        md={compact ? 24 : 24}
                    >
                        <Form form={form} layout="vertical" name="basic" onFinish={onSave}>
                            <Space direction="vertical" size="large">
                                <Row gutter={compact ? 12 : 0}>
                                    <Col md={compact ? 12 : 24}>
                                        <Card title="Informações Básicas">
                                            <Spin spinning={loading}>
                                                <Radio.Group
                                                    value={legalEntity}
                                                    style={{ marginBottom: '1rem', }}
                                                    onChange={(event) => {
                                                        const entity = event.target.value;
                                                        setLegalEntity(entity);
                                                        const { cnpj, businessName } = form.getFieldsValue();
                                                        const entityChanged = ((cnpj !== null && cnpj !== '') || (businessName !== null && businessName !== ''));
                                                        if (entity === PF && entityChanged) {
                                                            setShowLegalEntityModal(true);
                                                        }
                                                    }}
                                                    options={[
                                                        { value: PF, label: 'Pessoa Física' },
                                                        { value: PJ, label: 'Pessoa Jurídica' },
                                                    ]}
                                                />
                                                {createKycStatus()}
                                                <Form.Item name={["companyExternal"]} hidden={true} />
                                                {login.company.master && (
                                                    <Form.Item label="Empresa" name={["company", "id"]}>
                                                        <AutoCompleteCompany
                                                            disabled={id || isCreatingCompanyOperator ? true : false}
                                                            onChangeCompany={(value) =>
                                                                form.setFieldsValue({ companyExternal: value })
                                                            }
                                                        />
                                                    </Form.Item>
                                                )}
                                                {!id && isMasterUser && (
                                                    <Alert
                                                        style={{ marginBottom: '1rem' }}
                                                        type="info"
                                                        showIcon
                                                        message={isCreatingCompanyOperator
                                                            ? `O Operador de Empresas será cadastrado na empresa master (${login.company.name}).`
                                                            : `Sem empresa selecionada, o usuário será cadastrado na empresa master (${login.company.name}), que aceita apenas Operador ou Operador de Empresas.`}
                                                    />
                                                )}
                                                {login.company.master &&
                                                    data &&
                                                    data.otherCompanies &&
                                                    data.otherCompanies.length > 0 && (
                                                        <Form.Item label="Outras Empresas">
                                                            <Select
                                                                mode="multiple"
                                                                allowClear
                                                                style={{ width: "100%" }}
                                                                placeholder="Empresas"
                                                                defaultValue={data.otherCompanies.map(
                                                                    (d) => d.name
                                                                )}
                                                                disabled
                                                            ></Select>
                                                        </Form.Item>
                                                    )}
                                                {!compact && (
                                                    <Form.Item
                                                        hasFeedback
                                                        label="Tipo"
                                                        initialValue={"E"}
                                                        name={["userType", "code"]}
                                                    >
                                                        <Select placeholder="Selecione um tipo" disabled={isUserTypeLocked()}>
                                                            {availableUserTypes()
                                                                .map((x) => (
                                                                    <Select.Option value={x.code}>
                                                                        {x.name}
                                                                    </Select.Option>
                                                                ))}
                                                        </Select>
                                                    </Form.Item>
                                                )}
                                                <Form.Item noStyle>
                                                    <Form.Item
                                                        label="Nome"
                                                        hasFeedback
                                                        name="name"
                                                        rules={[
                                                            { required: true, message: "Insira um nome" },
                                                            { max: 120, message: 'Campo não deve exceder 120 caracteres' }
                                                        ]}
                                                    >
                                                        <Input
                                                            disabled={!canEditFields}
                                                            maxLength={120}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Item>
                                                    {openSocialName && (
                                                        <Form.Item
                                                            label="Nome de Registro"
                                                            hasFeedback
                                                            name="officialName"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Insira um nome de registro",
                                                                },
                                                                { max: 120, message: 'Campo não deve exceder 120 caracteres' }

                                                            ]}
                                                        >
                                                            <Input maxLength={120} autoComplete="off" />
                                                        </Form.Item>
                                                    )}
                                                </Form.Item>
                                                <Row gutter={compact ? 10 : 0}>
                                                    <Col md={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="CPF"
                                                            hasFeedback
                                                            name="cpf"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Insira um CPF válido",
                                                                },
                                                                {
                                                                    pattern: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/,
                                                                    message: 'CPF deve estar no formato 000.000.000-00'
                                                                }
                                                            ]}
                                                        >
                                                            <InputMask
                                                                disabled={!canEditCPF}
                                                                mask="999.999.999-99"
                                                                placeholder="000.000.000-00"
                                                                autoComplete="off"
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const cleanedValue = value.replace(/_/g, '');
                                                                    const isValidFormat = /^(\d{3}\.\d{3}\.\d{3}-\d{2})$/.test(cleanedValue);
                                                                    if (isValidFormat) {
                                                                        form.setFieldsValue({ cpf: cleanedValue });
                                                                    } else {
                                                                        form.setFieldsValue({ cpf: cleanedValue.slice(0, 14) });
                                                                    }
                                                                }}
                                                            >
                                                                {(inputProps) => (
                                                                    <Input
                                                                        {...inputProps}
                                                                        maxLength={14}
                                                                        autoComplete="off"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="Data de Nascimento"
                                                            hasFeedback
                                                            name="birthday"
                                                            rules={[{ required: true, message: "Insira uma data válida" }]}
                                                        >
                                                            <DatePicker
                                                                placeholder="DD/MM/AAAA"
                                                                disabledDate={(current) =>
                                                                    current &&
                                                                    (current > moment().endOf("day") ||
                                                                        current >= moment().subtract(16, "years").endOf("day"))
                                                                }
                                                                disabled={!canEditFields}
                                                                allowClear
                                                                format="DD/MM/YYYY"
                                                                style={{ width: "100%" }}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="Telefone"
                                                            hasFeedback
                                                            rules={[
                                                                { required: true, message: "Insira o número de telefone" },
                                                                { pattern: /^\(\d{2}\) \d{5}-\d{4}$/, message: 'Verifique o número de telefone' }
                                                            ]}
                                                            name="phone"
                                                        >
                                                            <InputMask
                                                                mask="(99) 99999-9999"
                                                                placeholder="(00) 00000-0000"
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const cleanedValue = value.replace(/_/g, '');
                                                                    const isValidFormat = /^\(\d{2}\) \d{5}-\d{4}$/.test(cleanedValue);
                                                                    if (isValidFormat) {
                                                                        form.setFieldsValue({ phone: cleanedValue });
                                                                    } else {
                                                                        form.setFieldsValue({ phone: cleanedValue.slice(0, 15) });
                                                                    }
                                                                }}
                                                            >
                                                                {(inputProps) => (
                                                                    <Input
                                                                        {...inputProps}
                                                                        addonBefore="+55"
                                                                        autoComplete="off"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="Sexo"
                                                            hasFeedback
                                                            name={["userSex", "code"]}
                                                            rules={[
                                                                { required: true, message: "Insira o sexo" },
                                                            ]}
                                                        >
                                                            <Select placeholder="Selecione um sexo">
                                                                <Select.Option value={null}></Select.Option>
                                                                {SEX_DATA.map((x) => (
                                                                    <Select.Option value={x.code}>
                                                                        {x.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Form.Item
                                                    label="E-mail"
                                                    hasFeedback
                                                    name="email"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            type: "email",
                                                            message: "Insira um e-mail válido",
                                                        },
                                                        { max: 80, message: 'Campo não deve exceder 80 caracteres' }

                                                    ]}
                                                >
                                                    <Input autoComplete="off" type="email" />
                                                </Form.Item>
                                                {legalEntity === PJ && (
                                                    <Col md={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="CNPJ"
                                                            hasFeedback
                                                            name="cnpj"
                                                            rules={[
                                                                {
                                                                    required: legalEntity === PJ,
                                                                    message: "Insira um CNPJ válido",
                                                                },
                                                                {
                                                                    pattern: /^(\d{14}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/,
                                                                    message: 'CNPJ deve estar no formato 00.000.000/0000-00'
                                                                }
                                                            ]}
                                                        >
                                                            <InputMask
                                                                // TODO: DISCOMMENT WHEN CREATE NEW BIN
                                                                // disabled={id ? true : false}
                                                                disabled={!!data?.disabledCnpj}
                                                                mask="99.999.999/9999-99"
                                                                placeholder="00.000.000/0000-00"
                                                                autoComplete="off"
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const cleanedValue = value.replace(/_/g, '');
                                                                    const isValidFormat = /^(\d{14}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/.test(cleanedValue);
                                                                    if (isValidFormat) {
                                                                        form.setFieldsValue({ cnpj: cleanedValue });
                                                                    } else {
                                                                        form.setFieldsValue({ cnpj: cleanedValue.slice(0, 18) });
                                                                    }
                                                                }}
                                                            >
                                                                {(inputProps) => (
                                                                    <Input
                                                                        {...inputProps}
                                                                        maxLength={18}
                                                                        autoComplete="off"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </Form.Item>

                                                        <Form.Item
                                                            label="Razão Social"
                                                            hasFeedback
                                                            name="businessName"
                                                            rules={[
                                                                {
                                                                    required: legalEntity === PJ,
                                                                    message: "Insira a razão social",
                                                                },
                                                            ]}
                                                        >
                                                            <Input autoComplete="off" />
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                                {wtCompany && wtCompany.enableCode && (
                                                    <Form.Item
                                                        label="Código do Participante"
                                                        hasFeedback
                                                        name="code"
                                                    >
                                                        <Input autoComplete="off" />
                                                    </Form.Item>
                                                )}
                                                <Form.Item
                                                    label="Nome da Mãe"
                                                    hasFeedback
                                                    name="mother"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            message: "Insira o nome da mãe",
                                                        },
                                                    ]}
                                                >
                                                    <Input autoComplete="off" />
                                                </Form.Item>
                                                {!compact && (
                                                    <React.Fragment>
                                                        <Form.Item
                                                            label="Renda Mensal"
                                                            hasFeedback
                                                            name="income"
                                                        >
                                                            <InputCurrency />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Estado Civil"
                                                            hasFeedback
                                                            name={["maritalStatus", "code"]}
                                                        >
                                                            <Select placeholder="Selecione um estado civil">
                                                                {MARITAL_STATUS_DATA.map((x) => (
                                                                    <Select.Option value={x.code}>
                                                                        {x.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Profissão"
                                                            hasFeedback
                                                            name={"occupation"}
                                                            rules={[{ required: true, message: "Selecione uma profissão" }]}
                                                        >
                                                            <Select
                                                                loading={occupations.length === 0}
                                                                placeholder="Buscar profissão"
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {occupations.map((x) => (
                                                                    <Select.Option key={x.id} value={Number(x.id)}>
                                                                        {x.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        {legalEntity === PF &&
                                                            <Form.Item
                                                                label="Faixa de faturamento Mensal"
                                                                name={["monthlyRevenueRange"]}
                                                                rules={[{ required: true, message: "Selecione uma faixa de faturamento Mensal" }]}
                                                            >
                                                                <Select disabled={id && form.monthlyRevenueRange ? true : false} placeholder="Selecione uma faixa de faturamento Mensal" allowClear>
                                                                    {MONTHLY_REVENUE_RANGE_DATA.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                                                </Select>
                                                            </Form.Item>
                                                        }
                                                        {legalEntity === PJ &&
                                                            <Form.Item
                                                                label="Faixa de faturamento Anual"
                                                                name={["annualRevenueRange"]}
                                                                rules={[{ required: true, message: "Selecione uma faixa de faturamento Anual" }]}
                                                            >
                                                                <Select disabled={id && form.annualRevenueRange ? true : false} placeholder="Selecione uma faixa de faturamento Anual" allowClear>
                                                                    {ANNUAL_REVENUE_RANGE_DATA.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                                                </Select>
                                                            </Form.Item>
                                                        }
                                                        <Form.Item
                                                            label="Unidade de negócio"
                                                            hasFeedback
                                                            name="businessUnit"
                                                            rules={[
                                                                { max: 100, message: "Campo não deve exceder 100 caracteres" }
                                                            ]}
                                                        >
                                                            <Input maxLength={100} autoComplete="off" />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Região"
                                                            hasFeedback
                                                            name="region"
                                                            rules={[
                                                                { max: 100, message: "Campo não deve exceder 100 caracteres" }
                                                            ]}
                                                        >
                                                            <Input maxLength={100} autoComplete="off" />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Diretoria"
                                                            hasFeedback
                                                            name="directorship"
                                                            rules={[
                                                                { max: 100, message: "Campo não deve exceder 100 caracteres" }
                                                            ]}
                                                        >
                                                            <Input maxLength={100} autoComplete="off" />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Campanha"
                                                            hasFeedback
                                                            name="campaign"
                                                            rules={[
                                                                { max: 100, message: "Campo não deve exceder 100 caracteres" }
                                                            ]}
                                                        >
                                                            <Input maxLength={100} autoComplete="off" />
                                                        </Form.Item>
                                                        <Form.Item
                                                            hasFeedback
                                                            name={"enabled"}
                                                            initialValue={true}
                                                            valuePropName="checked"
                                                        >
                                                            <SwitchLabel label="USUÁRIO ATIVO?" />
                                                        </Form.Item>

                                                        <Row gutter={24} align="middle">
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    label="Tipo de PIX"
                                                                    name={["pixType", "name"]}
                                                                >
                                                                    <Input disabled autoComplete="off" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    label=" "
                                                                    hasFeedback
                                                                    name={"validPix"}
                                                                    initialValue={false}
                                                                    valuePropName="checked"
                                                                >
                                                                    <SwitchLabel disabled label="PIX VÁLIDO?" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={24} align="middle">
                                                            <Col span={24}>{createAccountStatus()}</Col>
                                                        </Row>
                                                    </React.Fragment>
                                                )}
                                            </Spin>
                                        </Card>
                                    </Col>
                                    {!compact && legalEntity === PF && under18 &&
                                        (
                                            <Col md={24}>
                                                <Card style={{ marginTop: 15 }} title="Representante legal">
                                                    <Row gutter={24}>
                                                        <Col span={24}>
                                                            {createKycStatus(data?.legalRepresentative)}
                                                            <Form.Item
                                                                label="Tipo de representante legal"
                                                                name={["legalRepresentative", "relationshipType"]}
                                                                rules={[{ required: true, message: "Selecione um tipo de representante legal" }]}
                                                            >
                                                                <Select
                                                                    placeholder="Selecione um tipo de representante legal"
                                                                    allowClear
                                                                    onChange={(value) => {
                                                                        const previousType = legalRepTypeRef.current;
                                                                        legalRepTypeRef.current = value || null;
                                                                        if (!value) {
                                                                            form.setFieldsValue({ legalRepresentative: null });
                                                                            return;
                                                                        }

                                                                        if (value === "emancipated_minor" || previousType === "emancipated_minor") {
                                                                            form.resetFields([["legalRepresentative"]]);
                                                                            form.setFieldsValue({
                                                                                legalRepresentative: {
                                                                                    relationshipType: value,
                                                                                },
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    {(under18
                                                                        ? REPRESENTATIVE_LEGAL_DATA.filter(x => x.code === 'tutor' || x.code === 'emancipated_minor')
                                                                        : REPRESENTATIVE_LEGAL_DATA
                                                                    ).map((x) => (
                                                                        <Select.Option key={x.code} value={x.code}>
                                                                            {x.name}
                                                                        </Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Form.Item shouldUpdate noStyle>
                                                        {() => {
                                                            const relationshipType = form.getFieldValue([
                                                                "legalRepresentative",
                                                                "relationshipType",
                                                            ]);
                                                            if (!relationshipType) return null;
                                                            if (relationshipType === "emancipated_minor") return null;
                                                            return (
                                                                <React.Fragment>
                                                                    <Row gutter={24}>
                                                                        <Col span={24}>
                                                                            <Form.Item
                                                                                label="Nome"
                                                                                name={["legalRepresentative", "name"]}
                                                                                rules={[{ required: true, message: "Informe o nome do representante" }]}
                                                                            >
                                                                                <Input placeholder="Nome completo" />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row gutter={24}>
                                                                        <Col span={7}>
                                                                            <Form.Item
                                                                                label="CPF"
                                                                                name={["legalRepresentative", "document"]}
                                                                                rules={[{ required: true, message: "Informe o CPF do representante" },
                                                                                {
                                                                                    pattern: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/,
                                                                                    message: 'CPF deve estar no formato 000.000.000-00'
                                                                                }
                                                                                ]}
                                                                            >
                                                                                <InputMask
                                                                                    disabled={!canEditLegalCPF}
                                                                                    mask="999.999.999-99"
                                                                                    placeholder="000.000.000-00"
                                                                                    autoComplete="off"
                                                                                    onChange={(event) => {
                                                                                        const { value } = event.target;
                                                                                        const cleanedValue = value.replace(/_/g, '');
                                                                                        const isValidFormat = /^(\d{3}\.\d{3}\.\d{3}-\d{2})$/.test(cleanedValue);
                                                                                        if (isValidFormat) {
                                                                                            form.setFieldsValue({
                                                                                                legalRepresentative: {
                                                                                                    document: cleanedValue,
                                                                                                },
                                                                                            });
                                                                                        } else {
                                                                                            form.setFieldsValue({
                                                                                                legalRepresentative: {
                                                                                                    document: cleanedValue.slice(0, 14),
                                                                                                },
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {(inputProps) => (
                                                                                        <Input
                                                                                            {...inputProps}
                                                                                            maxLength={14}
                                                                                            autoComplete="off"
                                                                                        />
                                                                                    )}
                                                                                </InputMask>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={7}>
                                                                            <Form.Item
                                                                                label="Telefone"
                                                                                hasFeedback
                                                                                rules={[
                                                                                    { required: true, message: "Insira o número de telefone" },
                                                                                    { pattern: /^\(\d{2}\) \d{5}-\d{4}$/, message: 'Verifique o número de telefone' }
                                                                                ]}
                                                                                name={["legalRepresentative", "phoneNumber"]}
                                                                            >
                                                                                <InputMask
                                                                                    mask="(99) 99999-9999"
                                                                                    placeholder="(00) 00000-0000"
                                                                                    onChange={(event) => {
                                                                                        const { value } = event.target;
                                                                                        const cleanedValue = value.replace(/_/g, '');
                                                                                        const isValidFormat = /^\(\d{2}\) \d{5}-\d{4}$/.test(cleanedValue);
                                                                                        if (isValidFormat) {
                                                                                            form.setFieldsValue({
                                                                                                legalRepresentative: {
                                                                                                    ...(form.getFieldValue(["legalRepresentative"]) || {}),
                                                                                                    phoneNumber: cleanedValue,
                                                                                                },
                                                                                            });
                                                                                        } else {
                                                                                            form.setFieldsValue({
                                                                                                legalRepresentative: {
                                                                                                    ...(form.getFieldValue(["legalRepresentative"]) || {}),
                                                                                                    phoneNumber: cleanedValue.slice(0, 15),
                                                                                                },
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {(inputProps) => (
                                                                                        <Input
                                                                                            {...inputProps}
                                                                                            addonBefore="+55"
                                                                                            autoComplete="off"
                                                                                        />
                                                                                    )}
                                                                                </InputMask>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={10}>
                                                                            <Form.Item
                                                                                label="Faixa de faturamento Mensal"
                                                                                name={["legalRepresentative", "monthlyRevenueRange"]}
                                                                                rules={[{ required: true, message: "Selecione uma faixa de faturamento Mensal" }]}
                                                                            >
                                                                                <Select disabled={id && form.legalRepresentative?.monthlyRevenueRange ? true : false} placeholder="Selecione uma faixa de faturamento Mensal" allowClear>
                                                                                    {MONTHLY_REVENUE_RANGE_DATA.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={14}>
                                                                            <Form.Item
                                                                                label="E-mail"
                                                                                hasFeedback
                                                                                name={["legalRepresentative", "email"]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        type: "email",
                                                                                        message: "Insira um e-mail válido",
                                                                                    },
                                                                                    { max: 80, message: 'Campo não deve exceder 80 caracteres' }

                                                                                ]}
                                                                            >
                                                                                <Input autoComplete="off" type="email" />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={10}>
                                                                            <Form.Item
                                                                                label="Data de Nascimento"
                                                                                hasFeedback
                                                                                name={["legalRepresentative", "birthday"]}
                                                                                rules={[{ required: true, message: "Insira uma data válida" }]}
                                                                            >
                                                                                <DatePicker
                                                                                    placeholder="DD/MM/AAAA"
                                                                                    disabledDate={(current) =>
                                                                                        current &&
                                                                                        (current > moment().endOf("day") ||
                                                                                            current >= moment().subtract(16, "years").endOf("day"))
                                                                                    }
                                                                                    allowClear
                                                                                    format="DD/MM/YYYY"
                                                                                    style={{ width: "100%" }}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <Form.Item
                                                                                label=" "
                                                                                hasFeedback
                                                                                name={["legalRepresentative", "sameAddress"]}
                                                                                initialValue={false}
                                                                                valuePropName="checked"
                                                                            >
                                                                                <SwitchLabel noCase={true} label="Mesmo Endereço do Participante?" />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                    {!form.getFieldValue(["legalRepresentative", "sameAddress"]) &&
                                                                        <React.Fragment>
                                                                            <Typography level={1} style={{ marginTop: 10, marginBottom: 10 }}>
                                                                                Endereço do representante legal
                                                                            </Typography>
                                                                            <FormAddress
                                                                                loading={loading}
                                                                                form={form}
                                                                                prefix={["legalRepresentative"]}
                                                                                compact={compact}
                                                                                required={true}
                                                                                card={false}
                                                                                country={true}
                                                                            />
                                                                        </React.Fragment>
                                                                    }
                                                                </React.Fragment>
                                                            );
                                                        }}
                                                    </Form.Item>
                                                </Card>
                                            </Col>
                                        )}
                                    {!compact && id && (
                                        <Col md={compact ? 12 : 24}>
                                            <Card
                                                style={!compact ? { marginTop: 15 } : {}}
                                                title={cardActive.filter(card => card.cardType !== 'virtual').length === 0 ? "Cartão Físico" : "Cartões Físicos"}
                                                extra={
                                                    id && <Button
                                                        size="small"
                                                        type={"link"}
                                                        onClick={() => openHistoryCards(CARD_TYPE_PHYSICAL)}
                                                    >
                                                        Histórico
                                                    </Button>
                                                }
                                            >
                                                <Spin spinning={loading}>
                                                    {
                                                        cardActive.filter(card => card.cardType !== 'virtual')
                                                            .map((card, index) => (
                                                                <Row
                                                                    id={index}
                                                                    gutter={24}
                                                                    style={{
                                                                        marginBottom: cardActive.length === 0 ? 0 : 30,
                                                                    }}
                                                                >
                                                                    <Col xl={12}>
                                                                        <CreditCard
                                                                            name={data ? data.name : null}
                                                                            number={card ? card.number : null}
                                                                            cardType={card.cardType}
                                                                        />
                                                                    </Col>
                                                                    <Col xl={12}>
                                                                        {createCardStatus(card)}
                                                                        {card && !card.delivery && card.cardType === CARD_TYPE_PHYSICAL && (
                                                                            <Form.Item
                                                                                label=" "
                                                                                hasFeedback
                                                                                name={"card"}
                                                                                valuePropName="checked"
                                                                            >
                                                                                <SwitchLabel label="Cartão Entregue?" />
                                                                            </Form.Item>
                                                                        )}
                                                                        {card && card.id && (
                                                                            <Button
                                                                                block
                                                                                danger={card.status !== 'Bloqueado'}
                                                                                type="primary"
                                                                                onClick={() => blockCard(card, card.status === 'Bloqueado' ? 'active' : 'blocked')}
                                                                            >
                                                                                {(card.status === 'Bloqueado') ? 'Desbloquear' : 'Bloquear'}
                                                                            </Button>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            ))
                                                    }
                                                </Spin>
                                            </Card>
                                        </Col>
                                    )}
                                    {!compact && ((login.user.admin && login.company.corporateCard) || login.company.master) && (
                                        <Col md={24} style={{ marginTop: 15 }}>
                                            <Card title="Cartão Corporativo Virtual">
                                                {(() => {
                                                    const kycOk = data?.kycStatus === 'A';
                                                    const bioOk = data?.biometricStatus === 'APPROVED' || data?.biometricStatus === 'A';
                                                    const alreadyIssued = !!corporateCard;
                                                    const alreadyValid = kycOk && bioOk;
                                                    const tooltipMsg = alreadyIssued
                                                        ? "Cartão já emitido — campo bloqueado"
                                                        : alreadyValid
                                                            ? "KYC e biometria aprovados — cartão será emitido automaticamente"
                                                            : "";
                                                    return (
                                                        <Row align="middle" justify="space-between" style={{ marginBottom: 16 }}>
                                                            <Col>
                                                                <span style={{ fontSize: 15 }}>Emitir cartão ao concluir cadastro</span>
                                                            </Col>
                                                            <Col>
                                                                <Tooltip title={tooltipMsg}>
                                                                    <span>
                                                                        <Form.Item name="autoIssueCorporateCard" valuePropName="checked" noStyle>
                                                                            <Switch disabled={(id && loadingCorporateCard) || alreadyIssued || alreadyValid} />
                                                                        </Form.Item>
                                                                    </span>
                                                                </Tooltip>
                                                            </Col>
                                                        </Row>
                                                    );
                                                })()}
                                                {!id && (
                                                    <Typography.Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                                                        O cartão corporativo será emitido automaticamente quando o participante concluir o cadastro (KYC e biometria aprovados).
                                                    </Typography.Text>
                                                )}
                                                {id && <Spin spinning={loadingCorporateCard}>
                                                {!loadingCorporateCard && corporateCard ? (
                                                    <Row gutter={24}>
                                                        <Col xl={12}>
                                                            <CreditCard
                                                                name={corporateCard.name}
                                                                number={corporateCard.panMasked}
                                                                cardType="virtual"
                                                            />
                                                        </Col>
                                                        <Col xl={12}>
                                                            {createCardStatus({ status: corporateCard.status })}
                                                            <Button
                                                                block
                                                                danger
                                                                type="primary"
                                                                style={{ marginBottom: 8 }}
                                                                onClick={() => handleBlockCorporateCard()}
                                                            >
                                                                Bloquear
                                                            </Button>
                                                            <Tooltip title="Remove a conta corporativa do participante. O cartão será cancelado, o saldo disponível será devolvido para a empresa e esta ação não pode ser desfeita sem uma nova emissão de cartão.">
                                                                <Button
                                                                    block
                                                                    danger
                                                                    loading={removingCorporateAccount}
                                                                    onClick={handleRemoveCorporateAccountConfirm}
                                                                >
                                                                    Remover Conta
                                                                </Button>
                                                            </Tooltip>
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    !loadingCorporateCard && (() => {
                                                        const kycApproved = data?.kycStatus === 'A';
                                                        const bioApproved = data?.biometricStatus === 'APPROVED' || data?.biometricStatus === 'A';
                                                        if (kycApproved && bioApproved) {
                                                            return (
                                                                <Button
                                                                    type="primary"
                                                                    onClick={() => setIssueCardModal(true)}
                                                                >
                                                                    Emitir Cartão Virtual Corporativo
                                                                </Button>
                                                            );
                                                        }
                                                        return (
                                                            <Alert
                                                                type="warning"
                                                                showIcon
                                                                message="Cartão corporativo indisponível"
                                                                description={
                                                                    !kycApproved && !bioApproved
                                                                        ? 'KYC e biometria do participante estão pendentes de aprovação.'
                                                                        : !kycApproved
                                                                            ? 'KYC do participante está pendente de aprovação.'
                                                                            : 'Biometria do participante está pendente de aprovação.'
                                                                }
                                                            />
                                                        );
                                                    })()
                                                )}
                                                </Spin>}
                                            </Card>
                                            <Modal
                                                title="Emitir Cartão Corporativo"
                                                open={issueCardModal}
                                                onCancel={() => { setIssueCardModal(false); setCorporatePin(''); setCorporatePinConfirm(''); }}
                                                onOk={handleIssueCorporateCard}
                                                confirmLoading={issuingCorporateCard}
                                                okText="Emitir"
                                                cancelText="Cancelar"
                                            >
                                                {(() => {
                                                    const pinValidation = getPinValidation(corporatePin);
                                                    const hasInput = corporatePin.length === 4;
                                                    const ruleIcon = (key) => {
                                                        if (!hasInput) return <InfoCircleOutlined style={{ color: '#8c8c8c' }} />;
                                                        return pinValidation[key]
                                                            ? <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                                            : <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
                                                    };
                                                    return (
                                                        <Row gutter={[0, 16]}>
                                                            <Col span={24}>
                                                                <Input.Password
                                                                    placeholder="PIN (4 dígitos)"
                                                                    maxLength={4}
                                                                    value={corporatePin}
                                                                    onChange={e => setCorporatePin(e.target.value.replace(/\D/g, '').slice(0, 4))}
                                                                />
                                                            </Col>
                                                            <Col span={24}>
                                                                <Input.Password
                                                                    placeholder="Confirmar PIN"
                                                                    maxLength={4}
                                                                    value={corporatePinConfirm}
                                                                    onChange={e => setCorporatePinConfirm(e.target.value.replace(/\D/g, '').slice(0, 4))}
                                                                />
                                                            </Col>
                                                            <Col span={24}>
                                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                                    Use um PIN que não se enquadre nas combinações inválidas abaixo.
                                                                </Typography.Text>
                                                                <Table
                                                                    size="small"
                                                                    pagination={false}
                                                                    style={{ marginTop: 8 }}
                                                                    columns={[
                                                                        {
                                                                            title: 'Regra',
                                                                            dataIndex: 'rule',
                                                                            width: 120,
                                                                            render: (text, record) => (
                                                                                <Space>
                                                                                    {ruleIcon(record.key)}
                                                                                    <span>{text}</span>
                                                                                </Space>
                                                                            ),
                                                                        },
                                                                        {
                                                                            title: 'Descrição',
                                                                            dataIndex: 'description',
                                                                        },
                                                                        {
                                                                            title: 'Exemplos inválidos',
                                                                            dataIndex: 'examples',
                                                                            render: (text) => (
                                                                                <Space wrap>
                                                                                    {text.split(', ').map(ex => (
                                                                                        <Typography.Text key={ex} code>{ex}</Typography.Text>
                                                                                    ))}
                                                                                </Space>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                    dataSource={PIN_RULES}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    );
                                                })()}
                                            </Modal>
                                        </Col>
                                    )}
                                    {!compact && (
                                        <Col md={compact ? 12 : 24}>
                                            <Card
                                                style={!compact ? { marginTop: 15 } : {}}
                                                title={cardActive.filter(card => card.cardType === 'virtual').length === 0 ? "Cartão Virtual" : "Cartões Virtuais"}
                                                extra={
                                                    id && <Button
                                                        size="small"
                                                        type={"link"}
                                                        onClick={() => openHistoryCards(CARD_TYPE_VIRTUAL)}
                                                    >
                                                        Histórico
                                                    </Button>
                                                }
                                            >
                                                <Spin spinning={loading}>
                                                    <Col xl={compact ? 12 : 24}>
                                                        <Form.Item
                                                            label="Quantidade de cartões virtuais que usuário pode emitir pelo app:"
                                                            name="userIssueCardLimit"
                                                            initialValue={1}
                                                            hasFeedback
                                                            rules={[
                                                                { required: true, message: "Valor mínimo é um" },
                                                                { min: 1, pattern: /^\d$/, type: 'number', message: 'Campo numérico' },
                                                            ]}
                                                        >
                                                            <InputNumber style={{ width: '100%' }} disabled={isOperator()} min={1} />
                                                        </Form.Item>
                                                    </Col>
                                                    {
                                                        cardActive.filter(card => card.cardType === 'virtual').map((card, index) => (
                                                            <Row
                                                                id={index}
                                                                gutter={24}
                                                                style={{
                                                                    marginBottom: cardActive.length === 0 ? 0 : 30,
                                                                }}
                                                            >
                                                                <Col xl={12}>
                                                                    <CreditCard
                                                                        name={data ? data.name : null}
                                                                        number={card ? card.number : null}
                                                                        cardType={card.cardType}
                                                                    />
                                                                </Col>
                                                                <Col xl={12}>
                                                                    {createCardStatus(card)}
                                                                    {card && !card.delivery && card.cardType === CARD_TYPE_PHYSICAL && (
                                                                        <Form.Item
                                                                            label=" "
                                                                            hasFeedback
                                                                            name={"card"}
                                                                            valuePropName="checked"
                                                                        >
                                                                            <SwitchLabel label="Cartão Entregue?" />
                                                                        </Form.Item>
                                                                    )}
                                                                    {card && card.id && (
                                                                        <Button
                                                                            block
                                                                            danger={card.status !== 'Bloqueado'}
                                                                            type="primary"
                                                                            onClick={() => blockCard(card, card.status === 'Bloqueado' ? 'active' : 'blocked')}
                                                                        >
                                                                            {(card.status === 'Bloqueado') ? 'Desbloquear' : 'Bloquear'}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        ))
                                                    }
                                                </Spin>
                                            </Card>
                                        </Col>
                                    )}
                                    <Col
                                        md={compact ? 12 : 24}
                                        style={!compact ? { marginTop: 15 } : {}}
                                    >
                                        <FormAddress
                                            loading={loading}
                                            form={form}
                                            compact={compact}
                                            required={true}
                                            country={true}
                                        />
                                    </Col>
                                </Row>
                            </Space>
                        </Form>
                    </Col>
                </Row>
            </Content>
            {!compact && (
                <Footer style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Button
                        className="btn-save"
                        type="primary"
                        onClick={() => navigate(`/user`)}>
                        Voltar
                    </Button>
                    {!isOperator() && <>
                        <Button
                            disabled={loading || !id || isOperator()}
                            loading={loading}
                            className="btn-save"
                            type="primary"
                            icon={<SaveOutlined />}
                            onClick={() => setIsConfirmModalVisible(true)}
                        >
                            {data?.backofficeDisable ? "Habilitar" : "Excluir"}
                        </Button>
                        {
                            <Modal
                                width={400}
                                open={isConfirmModalVisible}
                                title={`Tem certeza de que deseja ${data?.backofficeDisable ? "habilitar" : "excluir"} esse participante?`}
                                okText="Sim"
                                cancelText="Não"
                                confirmLoading={isConfirmLoading}
                                onOk={() => {
                                    onDisable();
                                }}
                                onCancel={() => {
                                    setIsConfirmModalVisible(false);
                                }}
                            >
                            </Modal>
                        }
                    </>
                    }
                    <Button
                        disabled={loading}
                        loading={loading}
                        className="btn-save"
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={() => form.submit()}
                    >
                        Salvar
                    </Button>
                </Footer>
            )}
            <Modal
                open={cardHistoryShow}
                title={historyModalText}
                onCancel={() => setCardHistoryShow(false)}
                onOk={() => setCardHistoryShow(false)}
                width={600}
            >
                <Table
                    scroll={{ y: 400 }}
                    dataSource={cards}
                    loading={loadingCards}
                    pagination={false}
                    bordered
                >
                    <Table.Column
                        title="Número do Cartão"
                        dataIndex="cardNumber"
                        key="cardNumber"
                    />
                    <Table.Column
                        align="center"
                        width={150}
                        title="Atualizado em"
                        dataIndex="updatedAt"
                        key="updatedAt"
                        render={(value) => <FormatDate value={value} />}
                    />
                    <Table.Column
                        align="center"
                        width={150}
                        title="Status"
                        dataIndex="active"
                        key="active"
                        render={(value) => (value ? "Ativo" : "Bloqueado")}
                    />
                </Table>
            </Modal>

            <Modal
                open={showLegalEntityModal}
                title={"Alteração de Pessoa Jurídica"}
                onCancel={() => {
                    setShowLegalEntityModal(false)
                    if (legalEntity === PJ) {
                        setLegalEntity(PF);
                    } else {
                        setLegalEntity(PJ);
                    }
                }}
                onOk={() => {
                    form.setFieldsValue({
                        cnpj: null,
                        businessName: null,
                    });
                    setShowLegalEntityModal(false);
                }}
                width={600}
            >
                <p> Ao alterar a pessoa jurídica, os dados anteriores serão perdidos </p>
            </Modal>
        </Layout>
    );
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(UserDetailsScreen);
